<template>

  <div class="memberContainer mx-auto pxXxs15">
    <!-- / -->
    <b-alert v-if="propsEmailNotRegistered" show variant="danger" class="text-center">
      このメールアドレスは登録されていません。再度お試しください。
    </b-alert>
    <!-- / -->
		<p class="noticeBox fontSize14 mb30 mbXxs40 mbMd50 plMd20"><span class="d-inline-block">ご登録いただいているメールアドレスを</span><span class="d-inline-block">入力してください。</span><br><span class="d-inline-block">パスワード変更方法に関するメールを</span><span class="d-inline-block">お送り致します。</span></p>
    <!-- / -->
		<b-form name="formPasswordResetApply"
            method="POST"
            v-bind:action="propsPageUrl">
      <!-- nonce / -->
      <input type="hidden" id="_wpnonce" name="_wpnonce" v-bind:value="propsWpNonce" />
      <input type="hidden" name="_wp_http_referer" v-bind:value="propsPageUrl" />
      <!-- / nonce -->
			<div class="memberInfoBox pxMd20">
				<dl class="d-md-flex align-items-center mb0">
					<dt class="memberInfoTtl iconMemberEmail mb5 mbMd0">メールアドレス<br class="d-none d-md-inline">（半角英数）</dt>
          <!-- / -->
					<dd class="memberInfoData">
						<b-form-input v-validate="{
                            required:true,
                            email:true
                          }"
                          v-model="form.email"
                          type="text"
                          name="email"
                          data-vv-as="メールアドレス"
                          class="textBox"
                          placeholder="例）t_tanaka@example.com">
            </b-form-input>
					</dd>
				</dl>
        <!-- / -->
				<div v-if="veeErrors.first('email')" class="errMsgBox noticeBox mt10">
					<p class="errMsg">{{veeErrors.first('email')}}</p>
				</div>
			</div>
      <!-- / -->
			<div class="text-center mt40 mtXxs50 mtMd60">
				<b-button v-bind:disabled="veeErrors.any() || !form.email"
                  type="submit"
                  id="btnSendEmail"
                  variant="outline-primary"
                  class="btnProcedure">
                  送信する<i class="fa fa-angle-right ml-3"></i>
        </b-button>
			</div>
      <!-- / -->
		</b-form>
		<!-- /formPasswordResetApply -->

	</div>
	<!-- /memberContainer -->

</template>


<style scoped>
  input[type="text"] {
    height: 50px;
  }
</style>


<script>
    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        props: {
          propsWpNonce: {
            type: String
          },
          propsPageUrl: {
            type: String
          },
          propsEmailNotRegistered: {
            type: Boolean,
            default: false
          }
        },
        data: function() {
          return {
            form: {
              email: null
            }
          }
        },
        mounted() {
            console.log('PasswordResetRequestFormComponent mounted.')
        }
    }
</script>
